import React, { useState } from "react";
import "./Slider.css";

function Slider() {
  const [val, setVal] = useState(650);

  return (
    <>
      <div className="relative z-[-999]">
        <input
          type="range"
          className="w-[100%] absolute zero disable-thumb disable-track"
        />
        <input
          type="range"
          name=""
          disabled={true}
          id=""
          className="absolute one disable-thumb disable-track"
          style={{ width: val<750 ? (`${(val - 500) / 2.5}%`) : (`${100}%`) }}
        />
        <input
          type="range"
          name=""
          disabled={true}
          min={500}
          max={750}
          value={val}
          onChange={(e) => {
            setVal(e.target.value);
          }}
          id=""
          className="w-[100%] absolute thumb disable-track"
        />
      </div>

      <div className="number-tags z-[9] relative">
        <p className="absolute left-0 text-[10px] text-blackText font-semibold">
          500
        </p>
        {/* <p className="absolute left-[19%] text-[10px]">600</p>
        <p className="absolute left-[39%] text-[10px]">725</p>
        <p className="absolute right-[39%] text-[10px]">749</p>
        <p className="absolute right-[19%] text-[10px]">780</p> */}
        <p className="absolute right-0 text-[10px] text-blackText font-semibold">
          750
        </p>
      </div>
    </>
  );
}

export default Slider;
